import SettingTypes from "@/utils/setting-types"
import { uuid } from "@/utils/foundation"

export default {
  name: 'label-module',
  label: {
    title: '首页标签模块',
    icon: require('@/assets/icon-component-label_ImageSudoku.svg'),
    limit: 1
  },
  sort: 999,
  data: {
    // 标签列表
    tabsList: ['一', '二', '三', '四'].map(item => ({
      __key: uuid(),
      tabs_type: 'text',
      tabs_image: '',
      tabs_name: `标签${item}`,
      link: ''
    })),
    // 显示位置
    position: 'normal',
    // 导航类型
    tabs_tpl: 'normal',
    // 页面边距
    page_edge: 20,
    // 使用轮播图背景
    is_swiper_background: false,
    // 背景颜色
    background_color: '#ffffff',
    // 文字颜色
    text_color: '#303133',
    // 胶囊背景颜色
    capsule_background_color: '#fccccc',
    // 标签内边距
    tabs_padding_edge: 20,
    // 标签圆角
    tabs_margin_radius: 20,
    // 标签字体大小
    title_font_size: 28,
    // 标题字体粗细
    title_font_weight: '400',
    // 图片缩放大小
    image_scale: 0.6,
    // 图片宽度
    width: 160,
    // tab 的高度
    height: 88,
    // 下划线的高度
    line_height: 4,
    // 下划线的颜色
    line_color: '#f42424',
    // 下划线的缩放比例
    line_scale: 0.5
  },
  settings: {
    tabsList: {
      type: SettingTypes.custom,
      component_name: 'LabelModuleSelector'
    },
    position: {
      type: SettingTypes.radio_button,
      label: '显示位置',
      options: [
        { label: '正常模式', value: 'normal', icon: 'rb-icon-search-normal' },
        { label: '滚动至顶部固定', value: 'fixed-top', icon: 'rb-icon-search-sticky' }
      ]
    },
    tabs_tpl: {
      type: SettingTypes.radio_button,
      label: '标签类型',
      options: [
        { label: '常规', value: 'normal' },
        { label: '下划线', value: 'underline' },
        { label: '胶囊', value: 'capsule'}
      ]
    },
    height: {
      type: SettingTypes.slider,
      label: '标签高度',
      props: {
        min: 30,
        max: 100
      }
    },
    page_edge: {
      type: SettingTypes.slider,
      label: '页面边距',
      props: {
        min: 0,
        max: 30
      }
    },
    is_swiper_background: {
      type: SettingTypes.boolean,
      label: '是否使用轮播背景',
      props: {
        activeText: '是',
        inactiveText: '否'
      }
    },
    background_color: {
      type: SettingTypes.color_picker,
      label: '背景颜色',
      default: '#ffffff',
      show: (data) => !data.is_swiper_background
    },
    text_color: {
      type: SettingTypes.color_picker,
      label: '文字颜色',
      default: '#000000'
    },
    capsule_background_color: {
      type: SettingTypes.color_picker,
      label: '胶囊背景颜色',
      default: '#fccccc',
      show: (data) => data.tabs_tpl === 'capsule'
    },
    tabs_margin_radius: {
      type: SettingTypes.slider,
      label: '胶囊圆角',
      props: {
        min: 0,
        max: 750
      },
      show: (data) => data.tabs_tpl === 'capsule'
    },
    tabs_padding_edge: {
      type: SettingTypes.slider,
      label: '标签边距',
      props: {
        min: 0,
        max: 30
      }
    },
    title_font_size: {
      type: SettingTypes.radio_button,
      label: '标签大小',
      options: [
        { label: '大（16号）', value: 32, icon: 'rb-icon-font-x' },
        { label: '中（14号）', value: 28, icon: 'rb-icon-font-m' },
        { label: '小（12号）', value: 24, icon: 'rb-icon-font-s' }
      ]
    },
    title_font_weight: {
      type: SettingTypes.radio_button,
      label: '标签粗细',
      options: [
        { label: '常规体', value: '400', icon: 'rb-icon-font-regular' },
        { label: '加粗体', value: 'bold', icon: 'rb-icon-font-bold' }
      ]
    },
    image_scale: {
      type: SettingTypes.slider,
      label: '图片缩放',
      props: {
        min: 0.3,
        max: 1,
        step: 0.01
      }
    },
    width: {
      type: SettingTypes.slider,
      label: '图片宽度',
      props: {
        min: 60,
        max: 200
      }
    },
    line_height: {
      type: SettingTypes.slider,
      label: '下划线高度',
      props: {
        min: 1,
        max: 10
      },
      show: (data) => data.tabs_tpl === 'underline'
    },
    line_color: {
      type: SettingTypes.color_picker,
      label: '下划线颜色',
      default: '#f42424',
      show: (data) => data.tabs_tpl === 'underline'
    },
    line_scale: {
      type: SettingTypes.slider,
      label: '下滑线缩放',
      props: {
        min: 0,
        max: 1,
        step: 0.01
      },
      show: (data) => data.tabs_tpl === 'underline'
    }
  }
}